import React, { Component } from 'react';

import { ToggleSwitch } from '../form';
import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faLongArrowAltDown from '@fortawesome/fontawesome-free-solid/faLongArrowAltDown';
import classNames from 'classnames';


class AnnualSwitch extends Component {
  render () {
    const {checked, benefits} = this.props
    return <div className="annual-switch">
      {benefits && <div className={classNames({"annual-benefits": true, hide: !checked})}>Pay annually<br />and save {window.BF2019_SALE ? 'up to 50% ' : 'up to 22%'}<br /><FA icon={faLongArrowAltDown} className="arrow-icon" /></div>}
      <label>Pay annually  <ToggleSwitch input={this.props} /> Pay monthly</label>
    </div>
  }
}

export default AnnualSwitch;


// WEBPACK FOOTER //
// ./src/components/billing/AnnualSwitch.js